import type * as PrivfsClient from "privfs-client"

const privfsClient: typeof PrivfsClient = require("./privmx-client-2.7.2.js").privmx;

export = privfsClient;
